<template>
    <div class="places-container">
        <template v-if="! isCustomAddress">
            <vue-google-autocomplete
                id="map"
                ref="address"
                :classname="`input-text${dropdownIsOpened && shouldAddClassOnDropdownOpened ? ' input-text--dropdown-is-opened' : ''}`"
                :placeholder="placeholder"
                :country="['FR', 'BE', 'UK', 'ES', 'IT', 'CH', 'CA']"
                @placechanged="getAddressData"
                @inputChange="handleInputChange"
                @focus="handleInputFocus"
                @keypress="dropdownIsOpened = true"
                @blur="dropdownIsOpened = false"
            />
            <div
                v-if="noResult"
                @click="handleCustomAddressClick"
                :class="alternativeStyle ? 'no-result-dropdown-form-control' : 'no-result-dropdown'"
            >
                <strong>Adresse introuvable !</strong>&nbsp;Ajoutez une adresse manuellement
            </div>
            <icon class="places-container__pin" icon="localisation-5" />
        </template>
    </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete"

export default {
    props: {
        type: {
            type: String,
            required: false,
        },

        value: {
            required: false,
        },

        id: {
            required: false,
            default: 'address',
        },

        alternativeStyle: {
            required: false,
            default: null,
        },

        shouldAddClassOnDropdownOpened: {
            required: false,
            default: true,
        },
        placeholder: {
            required: false,
            default: 'Recherchez une adresse...',
            type: String,
        }
    },

    components: { VueGoogleAutocomplete },

    data() {
        return {
            address: '',
            dropdownIsOpened: false,
            noResult: false,
            isCustomAddress: false,
        }
    },

    mounted() {
        if (this.value) {
            this.$refs.address.update(this.value)
        }

        this.focusInput()
    },

    methods: {
        getAddressData: function (addressData, placeResultData, id) {
            this.address = addressData
            this.$emit('change', this.formattedAddress(addressData))
        },

        formattedAddress(addressData) {
            return {
                address: (addressData.street_number ? addressData.street_number : '')  + ' ' + addressData.route,
                city: addressData.locality,
                zip: addressData.postal_code,
                country: addressData.country,
                longitude: addressData.longitude,
                latitude: addressData.latitude,
            }
        },

        // async handleReset() {
        //     this.isCustomAddress = false
        //     this.$emit('customAddress', this.isCustomAddress)
        //     await this.$nextTick()
        //     this.focusInput()
        //     this.$refs.address.$el.focus()
        // },

        async getItemsLength(sleepDuration = 300) {
            await this.sleep(sleepDuration)
            return document.getElementsByClassName('pac-item').length
        },

        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms))
        },

        async handleInputChange(values) {
            if (values.newVal.length === 0) {
                this.dropdownIsOpened = false
                this.noResult = false
            }

            const itemsLength = await this.getItemsLength()

            this.noResult = false

            const items = document.getElementsByClassName('pac-item')

            if (values.newVal.length <= 1) {
                return
            }

            if (! itemsLength && this.address === '') {
                this.noResult = true
            }

            if (itemsLength || this.noResult) {
                this.dropdownIsOpened = true
            }

            this.address = ''
        },

        async handleInputFocus() {
            await this.$nextTick()

            const itemsLength = await this.getItemsLength(0)

            if (itemsLength > 0) {
                this.dropdownIsOpened = true
            }
        },

        handleCustomAddressClick() {
            this.dropdownIsOpened = false
            this.noResult = false
            this.isCustomAddress = true
            this.$emit('customAddress', this.isCustomAddress)
        },

        focusInput() {
            this.$refs.address.$el.focus()
        },
    },
};
</script>

<style>
.pac-container {
    box-shadow: none;
    border: 1px solid #dfeaf6;
    border-top: 0;
    border-radius: 0 0 6px 6px;
    width: 100%;
}

/* Hide the "Powered by Google" ad */
.pac-container:after {
    @apply hidden;
}

.pac-item {
    @apply font-sans;
    font-size: 14px !important;
    color: #494949 !important;
    border-top: 0 !important;
    padding: 6px 12px;
    cursor: pointer;
}

.pac-item-query {
    color: #494949 !important;
}

.pac-icon {
    @apply hidden;
}

.pac-item:before {
    display: none;
}

.input-text {
    @apply pr-6;
}
</style>

<style scoped>
.places-container {
    @apply relative;
}

.places-container__pin {
    @apply absolute right-0;
    color: var(--blue);
    top: 7px;
}

.no-result-dropdown,
.no-result-dropdown-form-control {
    @apply absolute w-full;
    z-index: 100;
}

.no-result-dropdown {
    @apply border-blue-lighter border h-16 text-xs border-t-0 cursor-pointer bg-white flex justify-center items-center;
    border-radius: 0 0 6px 6px;
}

.no-result-dropdown:hover {
    @apply border-blue-lighter border h-16 text-xs border-t-0 flex justify-center items-center cursor-pointer;
    background-color: #fafafa;
}

.no-result-dropdown-form-control {
    @apply text-lg cursor-pointer bg-white flex justify-center items-center;
    line-height: 30px;
    padding-top: 6px;
    padding-bottom: 6px;
    font-size: 14px;
    border-radius: 0 0 6px 6px;
    border-left: 1px solid var(--gray);
    border-right: 1px solid var(--gray);
    border-bottom: 1px solid var(--gray);
}

.no-result-dropdown-form-control:hover {
    background-color: #fafafa;
}


</style>
